var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 10.4167C1.16421 10.4167 1.5 10.7525 1.5 11.1667V12.8333C1.5 13.3395 1.91046 13.75 2.41667 13.75H12.8333C13.3395 13.75 13.75 13.3395 13.75 12.8333V11.1667C13.75 10.7525 14.0858 10.4167 14.5 10.4167C14.9142 10.4167 15.25 10.7525 15.25 11.1667V12.8333C15.25 14.168 14.168 15.25 12.8333 15.25H2.41667C1.08204 15.25 0 14.168 0 12.8333V11.1667C0 10.7525 0.335786 10.4167 0.75 10.4167Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.625 0C8.03921 0 8.375 0.335786 8.375 0.75V10.3333C8.375 10.7475 8.03921 11.0833 7.625 11.0833C7.21079 11.0833 6.875 10.7475 6.875 10.3333V0.75C6.875 0.335786 7.21079 0 7.625 0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.59467 8.13634C4.88756 7.84344 5.36244 7.84344 5.65533 8.13634L7.625 10.106L9.59467 8.13634C9.88756 7.84344 10.3624 7.84344 10.6553 8.13634C10.9482 8.42923 10.9482 8.9041 10.6553 9.197L8.15533 11.697C7.86244 11.9899 7.38756 11.9899 7.09467 11.697L4.59467 9.197C4.30178 8.9041 4.30178 8.42923 4.59467 8.13634Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.d8220e2dc5b433fc3241eb23911fffa2.svg";
export { ForwardRef as ReactComponent };